var _path, _path2, _path3, _path4, _path5, _mask, _g, _path6, _path7, _path8, _mask2, _g2, _path9, _path10, _path11, _mask3, _g3, _path12, _path13, _path14, _mask4, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthBkgIconCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 135,
    viewBox: "0 0 568 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.219 318.53C157.239 327.273 113.276 297.586 104.523 252.558L77.9137 115.662C69.1612 70.6344 98.8016 26.6399 143.781 17.8968C188.761 9.15357 232.724 38.841 241.477 83.8689L268.086 220.764C276.839 265.792 247.198 309.787 202.219 318.53Z",
    fill: "#7869B9",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.06 318.72C201.446 318.652 201.833 318.604 202.218 318.529C202.604 318.454 202.98 318.353 203.364 318.272L144.94 17.7072C144.554 17.7753 144.167 17.8212 143.781 17.8962C143.395 17.9712 143.02 18.0735 142.636 18.155L201.06 318.72Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.024 252.801C256.411 252.801 233 229.542 233 201.114V114.687C233 86.2591 256.411 63 285.024 63C313.637 63 337.047 86.2591 337.047 114.687V201.114C337.047 229.542 313.637 252.801 285.024 252.801Z",
    fill: "#4C3A97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.024 252.801V252.801C256.411 252.801 233 229.542 233 201.114V114.687C233 86.2591 256.411 63 285.024 63C313.637 63 337.047 86.2591 337.047 114.687V201.114C337.047 229.542 313.637 252.801 285.024 252.801",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.452 63H285.595V252.8H284.452V63Z",
    stroke: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 283,
    y: 62,
    width: 4,
    height: 192
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.452 63H285.595V252.8H284.452V63Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7421 182.071C55.2791 188.689 40.5206 184.786 33.9454 173.397L13.955 138.773C7.37976 127.384 11.3787 112.651 22.8417 106.033C34.3046 99.4149 49.0631 103.318 55.6383 114.707L75.6287 149.331C82.204 160.72 78.205 175.453 66.7421 182.071Z",
    fill: "#BDB4E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7421 182.071V182.071C55.2791 188.689 40.5206 184.786 33.9454 173.397L13.955 138.773C7.37976 127.384 11.3787 112.651 22.8417 106.033C34.3046 99.4149 49.0631 103.318 55.6383 114.707L75.6287 149.331C82.204 160.72 78.205 175.453 66.7421 182.071",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6127 106.165L23.0707 105.901L66.971 181.938L66.513 182.203L22.6127 106.165Z",
    stroke: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 105,
    width: 47,
    height: 78
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6127 106.165L23.0707 105.901L66.971 181.938L66.513 182.203L22.6127 106.165Z",
    fill: "white",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.867 228.471C463.318 241.36 491.345 234.468 504.151 213.157L543.082 148.364C555.887 127.052 548.814 99.0701 527.363 86.1812C505.913 73.2924 477.885 80.1839 465.08 101.496L426.148 166.288C413.343 187.6 420.416 215.582 441.867 228.471Z",
    fill: "#7869B9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M441.867 228.471V228.471C463.318 241.36 491.345 234.468 504.151 213.157L543.082 148.364C555.887 127.052 548.814 99.0701 527.363 86.1812C505.913 73.2924 477.885 80.1839 465.08 101.496L426.148 166.288C413.343 187.6 420.416 215.582 441.867 228.471",
    stroke: "white",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.792 86.4388L526.935 85.9237L441.439 228.213L442.296 228.728L527.792 86.4388Z",
    stroke: "white"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 440,
    y: 85,
    width: 89,
    height: 145
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.792 86.4388L526.935 85.9237L441.439 228.213L442.296 228.728L527.792 86.4388Z",
    fill: "white",
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.493 220.111C470.549 213.213 484.624 188.015 477.77 164.115L456.935 91.4542C450.082 67.5544 424.793 53.6437 400.737 60.5415C376.682 67.4393 362.607 92.6374 369.46 116.537L390.296 189.198C397.149 213.098 422.438 227.009 446.493 220.111Z",
    fill: "#BDB4E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M446.493 220.111V220.111C470.549 213.213 484.624 188.015 477.77 164.115L456.935 91.4542C450.082 67.5544 424.793 53.6437 400.737 60.5415C376.682 67.4393 362.607 92.6374 369.46 116.537L390.296 189.198C397.149 213.098 422.438 227.009 446.493 220.111",
    stroke: "white",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.218 60.4037L400.257 60.6793L446.012 220.248L446.974 219.973L401.218 60.4037Z",
    stroke: "white"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 399,
    y: 59,
    width: 49,
    height: 162
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.218 60.4037L400.257 60.6793L446.012 220.248L446.974 219.973L401.218 60.4037Z",
    fill: "white",
    stroke: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBkgIconCenter);
export default __webpack_public_path__ + "static/media/auth-bkg-icon-center.5f40dd784dec0001cca7e86a987df219.svg";
export { ForwardRef as ReactComponent };